
import clientAuth from "../clientAuth"
export default {
    index: (id) => clientAuth.get(`customer/document/pdf/${id}`), 
    store: (userData) => clientAuth.post('customer/document/store/pdf', { json: userData }),       
    show:(id)=>clientAuth.get(`customer/document/show/pdf/${id}`),
    update: (id,userData) => clientAuth.post(`customer/document/update/pdf/${id}`, { json: userData }),
    destroy: (id) => clientAuth.delete(`customer/document/delete/pdf/${id}`),
};